class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    // Half Past Fur — freeze the navbar in its current visual state.
    // Capture computed bg / filter and pin them as inline styles with
    // !important so neither :hover nor JS class changes can shift them
    // while the cart is open.
    const header = document.querySelector('.shopify-section-header');
    if (header && !header.classList.contains('shopify-section-header-sticky')) {
      const headerTop = header.querySelector('.header__top');
      const logo = header.querySelector('.header__heading-logo');
      const headerBg = getComputedStyle(header).backgroundColor;
      header.style.setProperty('background-color', headerBg, 'important');
      header.style.setProperty('transition', 'none', 'important');
      if (headerTop) {
        const topBg = getComputedStyle(headerTop).backgroundColor;
        headerTop.style.setProperty('background-color', topBg, 'important');
        headerTop.style.setProperty('transition', 'none', 'important');
      }
      if (logo) {
        const f = getComputedStyle(logo).backgroundColor;
        logo.style.setProperty('background-color', f, 'important');
        logo.style.setProperty('transition', 'none', 'important');
      }
      header.classList.add('hpf-cart-frozen');
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // Half Past Fur — unlock the frozen navbar and force the "white" state
    // until the user's mouse leaves the header. On first mouseleave (or
    // a safety timeout) revert to the natural at-rest overlay state.
    requestAnimationFrame(() => {
      const header = document.querySelector('.shopify-section-header');
      if (!header) return;

      const headerTop = header.querySelector('.header__top');
      const logo = header.querySelector('.header__heading-logo');

      // Clear the freeze inline styles so CSS can take over again.
      header.style.removeProperty('background-color');
      header.style.removeProperty('transition');
      if (headerTop) {
        headerTop.style.removeProperty('background-color');
        headerTop.style.removeProperty('transition');
      }
      if (logo) {
        logo.style.removeProperty('background-color');
        logo.style.removeProperty('transition');
      }
      header.classList.remove('hpf-cart-frozen');

      if (header.classList.contains('shopify-section-header-sticky')) return;
      if (!header.classList.contains('has-overlay')) return;

      // Force the "white" state via a class until mouse leaves the header.
      header.classList.add('hpf-post-cart-white');

      const cleanup = () => {
        header.classList.remove('hpf-post-cart-white');
        header.removeEventListener('mouseleave', cleanup);
        clearTimeout(safetyTimer);
      };
      header.addEventListener('mouseleave', cleanup, { once: true });
      // Safety net: if mouse never enters/leaves (e.g. mouse already off the
      // header at close), fade back to transparent after 2s.
      const safetyTimer = setTimeout(cleanup, 2000);
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
